export default "__VITE_ASSET__c626c8b9__"